<div class="modal">
  <div class="modal-header">
    <div>
      <mat-icon
      fontSet="material-icons-round"
      class="close-icon"
      >post_add</mat-icon>
      <span class="kbody-large">Catalog Suggestion Details</span>
    </div>
    <mat-icon
      fontSet="material-icons-round"
      class="close-icon"
      (click)="closeModal()"
      >close</mat-icon>
  </div>
  <div class="modal-content">
    <app-loading-spinner class="spinner" *ngIf="isLoading"></app-loading-spinner>
    <app-catalog-suggestion-review [showStatusRow]="true" *ngIf="!isLoading" [course]="course"></app-catalog-suggestion-review>
  </div>
  <div *ngIf="!isLoading" class="buttons">
    <!-- <app-button (click)="cancelSuggestion()" [class]="'red'" [text]="'Cancel Suggestion'"></app-button> -->
    <app-button (click)="closeModal()" [class]="'grey'" [text]="'Close this Window'"></app-button>
  </div>
</div>
